import { requestData, receiveData, receiveError } from '../api/http'
import CloudFlyerAPI from '../api/CloudFlyerAPI'

export const REQUESTING_TEMP_TOKEN = 'REQUESTING_TEMP_TOKEN'
export const TEMP_TOKEN_SUCCESS = 'TEMP_TOKEN_SUCCESS'
export const TEMP_TOKEN_ERROR = 'TEMP_TOKEN_ERROR'

export const FETCH_PROFILE_PENDING = 'FETCH_PROFILE_PENDING'
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS'
export const FETCH_PROFILE_ERROR = 'FETCH_PROFILE_ERROR'

export const LOGIN_PENDING = 'LOGIN_PENDING'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const LOGOUT_PENDING = 'LOGOUT_PENDING'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_ERROR = 'LOGOUT_ERROR'

export const REGISTER_PENDING = 'REGISTER_PENDING'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_ERROR = 'REGISTER_ERROR'

export const EDIT_CURRENT_USER = 'EDIT_CURRENT_USER'

export const RESEND_VERIFICATION_EMAIL_PENDING = 'RESEND_VERIFICATION_EMAIL_PENDING'
export const RESEND_VERIFICATION_EMAIL_SUCCESS = 'RESEND_VERIFICATION_EMAIL_SUCCESS'
export const RESEND_VERIFICATION_EMAIL_ERROR = 'RESEND_VERIFICATION_EMAIL_ERROR'

export const CHANGE_SLACK_SIDEBAR = 'CHANGE_SLACK_SIDEBAR'
export const CHANGE_SLACK_POPUP   = 'CHANGE_SLACK_POPUP'
export const NAV                  = 'NAV'

export const REFRESH_RM           = 'REFRESH_RM'

export function login(email, password) {
  return dispatch => {
    dispatch(requestData(LOGIN_PENDING))

    CloudFlyerAPI.user_account.login({
      email: email,
      password: password
    })
      .then(function (response) {
        dispatch(receiveData(LOGIN_SUCCESS, (response||{}).data))
      })
      .catch(function (err) {
        dispatch(receiveError(LOGIN_ERROR, err))
      })
  }
}

export function request_temp_token() {
  return dispatch => {
    dispatch(requestData(REQUESTING_TEMP_TOKEN))
  }
}

export function new_login(username, password, requestToken) {
  return dispatch => {
    dispatch(requestData(LOGIN_PENDING))
    CloudFlyerAPI.new_user_account.login({
      username,
      password,
      requestToken,
      type : 1
    })
    .then(function (response) {
      dispatch(receiveData(LOGIN_SUCCESS, (response||{}).data.jwtToken))
    })
    .catch(function (err) {
      dispatch(receiveError(LOGIN_ERROR, err))
    })
  }
}

export function refresh_profile(refresh) {
  return dispatch => {
    dispatch(requestData(FETCH_PROFILE_PENDING))

    let user = !refresh ? JSON.parse(localStorage.getItem('user')) : null

    // if (user) {
    //   console.log(user)
    //   return dispatch(receiveData(FETCH_PROFILE_SUCCESS, user))
    // }

    CloudFlyerAPI.new_user_account
      .me()
      .then(response=> {
        if(!response || !(response||{}).data){
          return dispatch(receiveError(FETCH_PROFILE_ERROR, ''))
        }
        // console.log("it s me", response);
        dispatch(receiveData(FETCH_PROFILE_SUCCESS, (response||{}).data))
      })
      .catch(err=> {
        console.log("localclear")
        localStorage.clear()
        dispatch(receiveError(FETCH_PROFILE_ERROR, err))
      })

  }
}

export function logout() {
  return dispatch => {
    dispatch(requestData(LOGOUT_PENDING))

    CloudFlyerAPI.user_account.logout()
    dispatch(receiveData(LOGOUT_SUCCESS, {}))
  }
}

export function register(account) {
  return dispatch => {
    dispatch(requestData(REGISTER_PENDING))

    CloudFlyerAPI.user_account.register(account)
      .then(response=> dispatch(receiveData(REGISTER_SUCCESS, {...(response||{}).data, email: account.email})))
      .catch(err=> dispatch(receiveError(REGISTER_ERROR, err)))
  }
}

export function update_user(data) {
  return dispatch => {
    CloudFlyerAPI
      .user_account
      .update(data)
      .then(() => dispatch(editCurrentUser(data)))
  }
}

export function editCurrentUser(data) {
  return {
    type: EDIT_CURRENT_USER,
    data
  }
}

export function resendVerificationEmail(data) {
  return dispatch => {
    dispatch(requestData(RESEND_VERIFICATION_EMAIL_PENDING))
    CloudFlyerAPI
      .user_account
      .resend_verification_email(data)
      .then(response => {
        dispatch(receiveData(RESEND_VERIFICATION_EMAIL_SUCCESS, (response||{}).data))
      })
      .catch(err => {
        dispatch(receiveError(RESEND_VERIFICATION_EMAIL_ERROR, err))
      })
  }
}

export function change_slack_sidebar (checked) {
  /*return dispatch => {
    dispatch(requestData(RESEND_VERIFICATION_EMAIL_PENDING))
    CloudFlyerAPI
      .user_account
      .resend_verification_email(data)
      .then(response => {
        dispatch(receiveData(RESEND_VERIFICATION_EMAIL_SUCCESS, (response||{}).data))
      })
      .catch(err => {
        dispatch(receiveError(RESEND_VERIFICATION_EMAIL_ERROR, err))
      })
  }*/

  return {
    type: CHANGE_SLACK_SIDEBAR,
    checked
  }
}

export function change_slack_popup (checked) {
  /*return dispatch => {
    dispatch(requestData(RESEND_VERIFICATION_EMAIL_PENDING))
    CloudFlyerAPI
      .user_account
      .resend_verification_email(data)
      .then(response => {
        dispatch(receiveData(RESEND_VERIFICATION_EMAIL_SUCCESS, (response||{}).data))
      })
      .catch(err => {
        dispatch(receiveError(RESEND_VERIFICATION_EMAIL_ERROR, err))
      })
  }*/

  return {
    type: CHANGE_SLACK_POPUP,
    checked
  }
}

export const refresh_rm  = ()=> {
  return {
    type: REFRESH_RM
  }
}
